const WORDS = ["Track your money", "Plug the leaks", "Let compounding work", "Protect what you build", "Fix it in the right order", "Build lasting wealth"];

export const Marquee = () => (
  <div className="bg-ink text-white overflow-hidden py-4 select-none" aria-hidden data-testid="marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {WORDS.map((w) => (
            <span key={w + k} className="flex items-center font-extrabold uppercase tracking-tight text-lg sm:text-2xl px-6">
              {w}
              <span className="ml-12 text-tang">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
